import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeText'
})
export class SanitizeTextPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }

  transform(url) {
    return this._sanitizer.bypassSecurityTrustHtml(url);
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_pipe/sanitize-text.pipe.ts